import { ExportOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useAppSelector } from 'utilities/hooks';

const SMXCON_DEV_ORIGIN = 'https://smxcondev.sitemax.io';
const LOCAL_JUNO_REDIRECT_URL = 'http://foo.sitemax.test:3000/redirect/';
const DEFAULT_REDIRECT_TO = '/documents';

const getCurrentRoute = () => {
    const route = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    return route || DEFAULT_REDIRECT_TO;
};

const canShowLocalJunoButton = () => window.location.origin === SMXCON_DEV_ORIGIN;

const LocalJunoButton = () => {
    const accessToken = useAppSelector((state) => state.auth.accessToken);

    if (!canShowLocalJunoButton()) {
        return null;
    }

    const handleOpenLocalJuno = () => {
        if (!accessToken) return;

        const url = new URL(LOCAL_JUNO_REDIRECT_URL);
        url.searchParams.set('token', accessToken);
        url.searchParams.set('redirectTo', getCurrentRoute());

        window.location.assign(url.toString());
    };

    return (
        <Tooltip title="Open local Juno">
            <Button
                disabled={!accessToken}
                icon={<ExportOutlined />}
                onClick={handleOpenLocalJuno}
                size="small"
                style={{ whiteSpace: 'nowrap' }}
            >
                Local
            </Button>
        </Tooltip>
    );
};

export default LocalJunoButton;
